import * as React from 'react';
import { useHistory } from 'react-router';
import routes from 'src/modules/Routing/routes';
import usePhotoViewer from 'src/share/components/PhotoViewer/usePhotoViewer';
import { MatchesService } from 'src/share/services/matches';
import { ChildInfoMatch } from '../ChildInfoMatch';
import MatchDetail from './components/MatchDetail';

const WebiqMatches = (props) => {
  const { caseInfo, childInfo, matchId } = props;
  const { handleZoomInImage } = usePhotoViewer();

  const history = useHistory();

  const deleteMatch = () => async () => {
    await MatchesService.deleteWebiqMatchById(matchId);
    history.replace(routes.WEBIQMATCHES);
  };

  return (
    <div className="matches-container">
      <ChildInfoMatch caseInfo={caseInfo} childInfo={childInfo} />
      <div key={matchId} className="match-info white-background">
        <MatchDetail
          onZoomImage={handleZoomInImage}
          {...props}
          deleteMatch={deleteMatch}
        />
      </div>
    </div>
  );
};

export default React.memo(WebiqMatches);



// WEBPACK FOOTER //
// ./src/modules/Recognition/Match/components/Webiq/WebiqMatches.tsx